import styled from 'styled-components';
import { themeGet } from '../theme';
export const StyledSvg = styled.svg `
  fill: ${({ $inverted = false }) => ($inverted ? themeGet('colors.gray.0') : themeGet('colors.gray.1000'))};
`;
